// extracted by mini-css-extract-plugin
export var actionButton = "_d1-0";
export var attachmentLine = "_d1-1";
export var fileInput = "_d1-2";
export var fileUploadWrapper = "_d1-4";
export var footer = "_d1-3";
export var modalContent = "_d1-5";
export var paperclip = "_d1-6";
export var quillEditor = "_d1-7";